function toggleMute(e) {
  console.log(e.target.id);
  var volume_button = document.querySelector('#' + e.target.id);
  var video = document.querySelector('.' + e.target.id.replace('button', 'video')).firstElementChild;
    
  if(video.muted) {
    video.muted = false;
    volume_button.classList.remove("muted");
    volume_button.classList.add("unmuted");
  } else {
    video.muted = true;
    volume_button.classList.remove("unmuted");
    volume_button.classList.add("muted");
  }
}